module.exports = __webpack_public_path__ + "img/familia.cee6af34.svg";